export class CustomerRegister{
   constructor(customer_register_id, customer_register_name, customer_register_last_name, 
      customer_register_email, customer_register_phone, customer_register_birthdate){
      this.customer_register_id = customer_register_id
      this.customer_register_name = customer_register_name
      this.customer_register_last_name = customer_register_last_name
      this.customer_register_email = customer_register_email
      this.customer_register_phone = customer_register_phone
      this.customer_register_birthdate = customer_register_birthdate
   }

   static fromServiceCustomers (customer_register) {
      return new CustomerRegister(
         customer_register.customer_register_id,
         customer_register.customer_register_name,
         customer_register.customer_register_last_name,
         customer_register.customer_register_email,
         customer_register.customer_register_phone,
         customer_register.customer_register_birthdate
         );
   }

}
